/**
 * for field: country
 * event: {
        eventHandler: 'wizardCountryHandler',
        on: 'change',
        options: {
            target: '#default_currency'
        },
    }
 * for field: is_vat_subject
     event: {
        listenOnlyEvent: 'change-currency-value'
    }

 @desc This magic function is used on the wizard field "country".
    If the value is "DE" or "AT",
    the wizard field "currency" is changed to "EUR" and the wizard vat field display is changed to hidden
    additionally, we have to disable/enable data validation and the required attributes for validateField
 */
document.addEventListener('alpine:init', () => {
    window.Alpine.magic('wizardCountryHandler', () => (event) => {
        let value = event.detail.value;
        let currencyValue = value === 'CH' ? 'CHF' : 'EUR';
        let isVatValue = value === 'CH' ? '' : '0';
        if (value !== 'CH') {
            window.dispatchEvent(new CustomEvent('change-is-vat-subject', {
                detail: {
                    value: isVatValue
                }
            }));
        }

        window.dispatchEvent(new CustomEvent('change-currency-value', {
            detail: {
                value: currencyValue
            }
        }));


    });
});
